(() => {
  if (customElements.get('jacc-live-emblem')) return;

  class JaccLiveEmblem extends HTMLElement {
    connectedCallback() {
      if (this.updateTimer) return;

      this.lastStrikeKey = '';

      this.updateClock = () => {
        const now = new Date();
        const minutes = now.getMinutes() + now.getSeconds() / 60;
        const hours = (now.getHours() % 12) + minutes / 60;

        this.style.setProperty('--jacc-minute-angle', `${minutes * 6}deg`);
        this.style.setProperty('--jacc-hour-angle', `${hours * 30}deg`);
        this.style.setProperty('--jacc-second-angle', `${now.getSeconds() * 6}deg`);

        const strikeMinute = now.getMinutes();
        if ((strikeMinute === 0 || strikeMinute === 30) && now.getSeconds() < 2) {
          const strikeKey = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${now.getHours()}-${strikeMinute}`;
          if (strikeKey !== this.lastStrikeKey) {
            this.lastStrikeKey = strikeKey;
            this.triggerStrike();
          }
        }
      };

      this.handleVisibility = () => {
        if (document.visibilityState === 'visible') this.updateClock();
      };

      document.addEventListener('visibilitychange', this.handleVisibility);
      this.updateClock();
      this.updateTimer = window.setInterval(this.updateClock, 1000);
    }

    disconnectedCallback() {
      if (this.updateTimer) window.clearInterval(this.updateTimer);
      if (this.visualTimer) window.clearTimeout(this.visualTimer);
      this.updateTimer = null;
      this.visualTimer = null;
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    triggerStrike() {
      this.classList.remove('is-striking');
      void this.offsetWidth;
      this.classList.add('is-striking');
      if (this.visualTimer) window.clearTimeout(this.visualTimer);
      this.visualTimer = window.setTimeout(() => this.classList.remove('is-striking'), 1500);
    }
  }

  customElements.define('jacc-live-emblem', JaccLiveEmblem);
})();
